const state = {
  singleResult: {
    code: '',
  }, // 单卡查询结果
  multiResult: [], // 多卡查询结果列表
}

const getters = {
  singleResult: (state) => state.singleResult,
  multiResult: (state) => state.multiResult
}

const mutations = {
  SET_SINGLE_RESULT(state, data) {
    state.singleResult = data
  },
  SET_MULTI_RESULT(state, data) {
    state.multiResult = data
  }
}

const actions = {
  setSingleResult({ commit }, data) {
    commit('SET_SINGLE_RESULT', data)
  },
  setMultiResult({ commit }, data) {
    commit('SET_MULTI_RESULT', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
